export default {
  headerPadding: '1.25rem 0 0 0',
};
